<p class="control" [ngClass]="direction === directions.LEFT ? 'has-icons-left' : 'has-icons-right'">
  <input
    #searchRef
    class="input is-medium"
    type="text"
    placeholder="{{ placeholder }}"
    (input)="onSearch(searchRef.value)"
    data-e2e="input-search-autocomplete"
    [attr.id]="id"
    portalAutoFocus
    [maxLength]="400"
    [(ngModel)]="searchInputValue"
  />
  <span class="icon is-small" [ngClass]="direction === directions.LEFT ? 'is-left' : 'is-right'"> <i class="fas fa-search" aria-hidden="true"></i> </span>
</p>
